/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IInternalMappingsJobsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.IInternalMappingsJobsInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type IInternalMappingsJobsQuery = {
  __typename?: 'Query';
  internalMappingsJobs: {
    __typename: 'InternalMappingsJobsConnection';
    edges: Array<{
      __typename: 'InternalMappingsJobEdge';
      cursor: string;
      node: {
        __typename: 'InternalMappingsJob';
        id: string;
        regulationId: string;
        clientCode: string;
        regulationName: string;
        documentName?: string | null;
        createdAt: string;
        publishedAt?: string | null;
        status: Types.IInternalMappingsJobStatus;
      };
    }>;
    pageInfo: { __typename: 'CursorPageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export const InternalMappingsJobsDocument = gql`
  query internalMappingsJobs($input: InternalMappingsJobsInput, $first: Int, $after: String) {
    internalMappingsJobs(input: $input, first: $first, after: $after) {
      __typename
      edges {
        __typename
        node {
          __typename
          id
          regulationId
          clientCode
          regulationName
          documentName
          createdAt
          publishedAt
          status
        }
        cursor
      }
      pageInfo {
        __typename
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useInternalMappingsJobsQuery__
 *
 * To run a query within a React component, call `useInternalMappingsJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalMappingsJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalMappingsJobsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInternalMappingsJobsQuery(
  baseOptions?: Apollo.QueryHookOptions<IInternalMappingsJobsQuery, IInternalMappingsJobsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IInternalMappingsJobsQuery, IInternalMappingsJobsQueryVariables>(
    InternalMappingsJobsDocument,
    options,
  );
}
export function useInternalMappingsJobsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IInternalMappingsJobsQuery, IInternalMappingsJobsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IInternalMappingsJobsQuery, IInternalMappingsJobsQueryVariables>(
    InternalMappingsJobsDocument,
    options,
  );
}
// @ts-ignore
export function useInternalMappingsJobsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IInternalMappingsJobsQuery, IInternalMappingsJobsQueryVariables>,
): Apollo.UseSuspenseQueryResult<IInternalMappingsJobsQuery, IInternalMappingsJobsQueryVariables>;
export function useInternalMappingsJobsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IInternalMappingsJobsQuery, IInternalMappingsJobsQueryVariables>,
): Apollo.UseSuspenseQueryResult<IInternalMappingsJobsQuery | undefined, IInternalMappingsJobsQueryVariables>;
export function useInternalMappingsJobsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IInternalMappingsJobsQuery, IInternalMappingsJobsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IInternalMappingsJobsQuery, IInternalMappingsJobsQueryVariables>(
    InternalMappingsJobsDocument,
    options,
  );
}
export type InternalMappingsJobsQueryHookResult = ReturnType<typeof useInternalMappingsJobsQuery>;
export type InternalMappingsJobsLazyQueryHookResult = ReturnType<typeof useInternalMappingsJobsLazyQuery>;
export type InternalMappingsJobsSuspenseQueryHookResult = ReturnType<typeof useInternalMappingsJobsSuspenseQuery>;
export type InternalMappingsJobsQueryResult = Apollo.QueryResult<
  IInternalMappingsJobsQuery,
  IInternalMappingsJobsQueryVariables
>;
